import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ecertReplace',
  standalone: false,
})
export class EcertReplacePipe implements PipeTransform {
  async transform(value: string, needle: string, replacement: string): Promise<string> {
    const prompt = value ? value.replace(needle, replacement) : '';
    return prompt;
  }
}
